var _path, _path2, _rect, _rect2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 210 220",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 88.055 13 L 121.945 13 C 130.296 13 137.319 18.371 139.352 25.656 L 170.946 25.656 C 176.469 25.656 180.946 30.133 180.946 35.656 L 180.946 184.345 C 180.946 189.868 176.469 194.345 170.946 194.345 L 39.053 194.345 C 33.53 194.345 29.053 189.868 29.053 184.345 L 29.053 35.656 C 29.053 30.133 33.53 25.656 39.053 25.656 L 70.648 25.656 C 72.681 18.371 79.704 13 88.055 13 Z M 139.945 47 L 70.055 47 L 70.055 36.702 L 39 36.702 L 39 183.298 L 171 183.298 L 171 36.702 L 139.945 36.702 Z",
    stroke: "#000",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 67.871 91.671 L 92.619 66.922 C 93.027 66.514 93.523 66.249 94.045 66.125 C 95.169 65.562 96.574 65.749 97.511 66.686 L 117.214 86.39 L 128.391 75.214 L 121.956 68.779 L 149.121 61.727 L 142.068 88.891 L 135.462 82.285 L 122.797 94.949 C 122.659 95.211 122.48 95.458 122.26 95.678 L 119.432 98.506 C 118.822 99.116 118.014 99.409 117.215 99.383 C 116.415 99.409 115.608 99.116 114.998 98.506 L 112.169 95.678 C 111.949 95.458 111.77 95.212 111.633 94.95 L 95.183 78.5 L 74.942 98.742 C 73.77 99.914 71.871 99.914 70.699 98.742 L 67.871 95.914 C 66.699 94.742 66.699 92.843 67.871 91.671 Z",
    stroke: "#000",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.226,
    y: 127.374,
    width: 53.792,
    height: 10,
    rx: 3,
    ry: 3,
    stroke: "#000",
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.226,
    y: 155.159,
    width: 53.792,
    height: 10,
    rx: 3,
    ry: 3,
    stroke: "#000",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 64.518 124.825 L 73.666 133.973 L 87.764 119.875 C 88.936 118.704 90.835 118.704 92.007 119.875 L 93.421 121.289 C 94.592 122.461 94.592 124.36 93.421 125.532 L 77.634 141.319 C 77.523 141.488 77.394 141.647 77.246 141.795 L 75.831 143.209 C 75.236 143.804 74.454 144.097 73.675 144.088 C 72.889 144.101 72.099 143.809 71.5 143.21 L 70.086 141.795 C 69.937 141.646 69.808 141.486 69.697 141.317 L 58.861 130.482 C 57.689 129.31 57.689 127.41 58.861 126.239 L 60.275 124.825 C 61.447 123.653 63.346 123.653 64.518 124.825 Z",
    stroke: "#000",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 64.518 152.402 L 73.666 161.55 L 87.764 147.452 C 88.936 146.281 90.835 146.281 92.007 147.452 L 93.421 148.866 C 94.592 150.038 94.592 151.938 93.421 153.109 L 77.634 168.896 C 77.523 169.065 77.394 169.224 77.246 169.372 L 75.831 170.787 C 75.234 171.384 74.448 171.676 73.666 171.665 C 72.883 171.676 72.097 171.384 71.5 170.787 L 70.086 169.373 C 69.937 169.224 69.808 169.064 69.697 168.895 L 58.861 158.059 C 57.689 156.887 57.689 154.988 58.861 153.816 L 60.275 152.402 C 61.447 151.23 63.346 151.23 64.518 152.402 Z",
    stroke: "#000",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.08cc4228c37b6b44da8637aa56224a6e.svg";
export { ForwardRef as ReactComponent };